import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: "",
  list: [],
  byId: {},
};

const TagRulesSlice = createSlice({
  name: "TagRules",
  initialState,
  reducers: {
    recieveTagRules(state, action) {
      // Kept in the order the server sent, which IS priority order -- the
      // drawer's matcher takes the first match, so re-sorting here would
      // silently change which tag a title gets.
      state.list = action.payload
      state.byId = Object.fromEntries(action.payload.map(rule => [rule.id, rule]));
    },
  },
});

export const {
  recieveTagRules
} = TagRulesSlice.actions

export default TagRulesSlice.reducer;
